import '../styles/Header.css';
import { FaBars, FaTimes } from 'react-icons/fa';
import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navRef = useRef();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  // Detect outside clicks
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuOpen && navRef.current && !navRef.current.contains(event.target)) {
        closeMenu();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [menuOpen]);

  return (
    <header className="header">
      <div className="nav-container">
        <div className="logo">
          <img src="/images/cvey-logo.jpg" alt="CVEY Logo" className="logo-img" />
          <span className="logo-text">CVEY Solutions</span>
        </div>
        <nav
          className={`nav-links ${menuOpen ? 'active' : ''}`}
          ref={navRef}
        >
          <Link to="/login" onClick={closeMenu}>Login</Link>
          <Link to="/pay-intern" className="nav-link">Pay for the Paid Intern</Link>

          {/* <a href="#services" onClick={closeMenu}>Services</a> */}
          <a href="#contact" onClick={closeMenu}>Contact</a>
        </nav>

        <div
          className={`hamburger ${menuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>
      </div>
    </header>
  );
};

export default Header;
